import { Components, Theme } from "@mui/material/styles"
import LinkBehavior from "./link-behaviour"
import { LinkProps } from "@mui/material"

declare module "@mui/material/OutlinedInput" {
  interface OutlinedInputProps {
    variant?: "rounded"
  }
}

const themeComponents: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: "none"
      }
    }
  },
  MuiLink: {
    defaultProps: {
      component: LinkBehavior
    } as LinkProps
  },
  MuiDivider: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderWidth: "1px",
        borderColor: theme.palette.divider
      })
    }
  },
  MuiChip: {
    styleOverrides: {
      root: () => ({
        padding: "0px 3px"
      })
    }
  },
  MuiPopover: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiPaper-root": {
          borderRadius: 2,
          width: "200px",
          border: `1px solid ${theme.palette.action.hover}`,
          background: theme.palette.background.default
        }
      })
    }
  },
  MuiTextField: {
    styleOverrides: {
      root: ({ theme }) => {
        const inputPalette = (theme.palette as any).input as
          | { boxBgColor?: string; placeholderColor?: string }
          | undefined
        return {
          fontSize: theme.typography.body1.fontSize,
          "& .MuiOutlinedInput-root": {
            backgroundColor: inputPalette?.boxBgColor
          },
          "& .MuiInputBase-input::placeholder": {
            color: inputPalette?.placeholderColor,
            opacity: 1
          },
          input: {
            fontSize: theme.typography.body1.fontSize,
            padding: "9px 12px"
          }
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => {
        const inputPalette = (theme.palette as any).input as
          | { boxBgColor?: string; placeholderColor?: string }
          | undefined
        return {
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.body1.fontSize,
          borderRadius: "8px",
          backgroundColor: inputPalette?.boxBgColor,
          // padding: "6px 10px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.divider,
            borderRadius: "8px"
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.action.active
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.action.active
          },
          "& input::placeholder": {
            color: inputPalette?.placeholderColor,
            opacity: 1
          }
        }
      },
      input: {
        padding: "6px 10px"
      }
    },
    variants: [
      {
        props: { variant: "rounded" },
        style: ({ theme }) => ({
          borderRadius: "50px", // Rounded input field
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.divider,
            borderRadius: "50px"
          },
          "&:hover": {
            borderColor: theme.palette.secondary.main // Change border color on hover
          },
          "&.Mui-focused": {
            borderColor: theme.palette.primary.dark, // Darker primary on focus
            boxShadow: `0px 0px 1px ${theme.palette.primary.light}` // Subtle glow effect
          }
        })
      }
    ]
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
          paddingTop: "3px",
          paddingBottom: "3px",
          backgroundColor: theme.palette.input?.boxBgColor
        },
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.palette.input?.boxBgColor
        },
        "& .MuiInputBase-input::placeholder": {
          color: theme.palette.input?.placeholderColor,
          opacity: 1
        }
      })
    }
  }
}

export default themeComponents
